import { jsx as _jsx } from "react/jsx-runtime";
import { getLayouts } from './layouts';
import TabelaBase from '../../library/TabelaBase';
export default function TabelaRetorno(props) {
    var _a, _b;
    const { titulo, rows, layout, periodo, datas } = props;
    let tituloTabela = titulo;
    if (!tituloTabela && datas) {
        tituloTabela = `Retorno da Carteira x Benchmarks. Período de análise: de ${(_a = datas.data_ini) !== null && _a !== void 0 ? _a : '-'} a ${(_b = datas.data_fim) !== null && _b !== void 0 ? _b : '-'}`;
    }
    return (_jsx(TabelaBase, { rows: rows, layout: layout, titulo: tituloTabela, layouts: getLayouts(periodo), height: 300 }));
}
